import { motion } from 'framer-motion'
import styled from 'styled-components'

import { button } from 'components/Editor/styled/Button'

const AreaContainerStyled = styled(motion.div)`
  ${button}
  position: absolute;
  width: 100%;
  height: 100%;
`

export default AreaContainerStyled
